module.exports = "\r\n@media (min-width: 768px) {\r\n\r\n    .show-in-desktop{\r\n        display: block !important;\r\n        padding-bottom:10px;\r\n        padding-top:10px;\r\n    }\r\n\r\n    .hide-in-desktop{\r\n        display:none;\r\n    }\r\n\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/devotee/dasara-festival/dasara-festival.component.css
// module id = ./src/app/devotee/dasara-festival/dasara-festival.component.css
// module chunks = main